import styled, { css } from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";

const countryCodePlaceholder = css`
  .countryCodePlaceholder {
    padding: 0 24px 0 32px !important;
  }
`;

export const InputWrapperV2 = styled(FlexDiv)`
  flex-direction: column;
  width: 100%;
  > div > div {
    margin-bottom: 7px !important;
  }
  input {
    font-family: var(--dm-sans);
    font-size: 14px;
    line-height: 18px;
    color: var(--text-black);
    padding: 11px 24px 11px 32px !important;
    &.phoneInput {
      padding: 11px 24px 11px 100px !important;
    }
  }
  .icon {
    left: 8px !important;
    &.icon-caret-down {
      left: unset !important;
    }
  }
  .form-input-error {
    margin-top: 4px;
    margin-left: 8px;
  }
`;

export const InputGroupV2 = styled(FlexDiv)`
  flex-direction: column;
  position: relative;
  margin-bottom: 12px;
  ${countryCodePlaceholder}
`;

export const InputWrapperV3 = styled(FlexDiv)`
  flex-direction: column;
  width: 100%;
  input {
    font-family: var(--dm-sans);
    font-size: 14px;
    line-height: 18px;
    color: var(--text-black);
    padding: 0 2px;
    border: none;
    padding: 15px 24px;
    border-radius: 47px;
    background-color: #fff;
  }
  .form-input-error {
    margin-top: 4px;
    margin-left: 8px;
  }
`;

export const InputGroupV3 = styled(FlexDiv)`
  flex-direction: column;
  position: relative;
  margin-bottom: 12px;

  & div:before {
    content: none;
  }
`;
